export const registraties = state => state.registraties;
export const registratie = state => state.registratie;
